module.exports = __webpack_public_path__ + "images/emoji/heavy_minus_sign.e0d0e5fc8b46ef525034.png";